module.exports = __webpack_public_path__ + "media/images/home-banners/main-background-3b7e55d824d558ec24863ea275b0d5da.jpg";